///include /assets/js/app/s/basket.js
///include /assets/js/app/s/catalogue.js
///include /assets/js/app/p/sbproduct/domain.js
///include /assets/js/app/s/sdomain-store.js
///include /assets/js/plugins/dacController.js
"use strict"

class SDomainSearchPage {
    init() {
        this.view = new Vue({
            el: "#domain-search-container",
            data: {
                basketClient: AnyBasket.inst,
                domainStore: AnyDomainStore.inst,
                userCatalogue: UserCatalogue.inst,
                settings: SharedSettings.inst,
            },
            computed: {
                brand() {
                    return window.brand
                },
                loading() {
                    return !(
                        this.domainStore.yearsByTld &&
                        this.userCatalogue.products
                    );
                }
            },
            watch: {
                loading(v) {
                    if(!v) {
                        Vue.nextTick( () => {
                            $( ".page-loaded-content" ).fadeTo(200,1, function() {});
                        });
                    }
                }
            },
            delimiters: ["[[", "]]"],
            components: {
                domainSearch: DomainSearch,
            },
            async mounted() {
                this.userCatalogue.assertExists()
                await this.userCatalogue.preloadSingle("currencySymbol")
                DRStatus.currencySymbol = UserCatalogue.inst.currencySymbol
            },
        })
    }
}
